// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"300":"b49702bf9f47d754","1768":"479d064254210770","2359":"b9edb7667dfe5954","3286":"34804a84d5fa0c5c","8023":"066c0f0e355b2c81"}[chunkId] + ".js";
};